var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"a_link edit-icon-color",staticStyle:{"color":"black !important"},attrs:{"data-toggle":"modal","data-target":"#create_edit_customer_popup","href":"#"},on:{"click":_vm.sendCustomerId}},[_c('i',{staticClass:"fa fa-pencil ico_sty"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }